@if (loading()) {
  <div class="attachment-empty-state" aria-live="polite">Loading attachments...</div>
} @else {
  <div class="attachment-summary-tile">
    <div class="attachment-summary-icon" aria-hidden="true"></div>
    <div class="attachment-summary-details">
      <div class="attachment-summary-label">Files Attached</div>
      <div class="attachment-summary-count">
        {{ attachments().length }}
      </div>
    </div>
    @if (attachments().length > 0) {
      <button
        type="button"
        class="attachment-view-button"
        aria-label="View attachments"
        (click)="open(0)"
      >
        View Attachments
      </button>
    }
  </div>
}

@if (selectedAttachment(); as attachment) {
  <div class="attachment-modal-backdrop" role="presentation" (click)="close()">
    <section
      class="attachment-modal"
      role="dialog"
      aria-modal="true"
      [attr.aria-label]="getFileName(attachment)"
      (click)="$event.stopPropagation()"
    >
      <div class="attachment-modal-header">
        <div class="attachment-modal-file-name">Attachments</div>
        <button type="button" class="attachment-icon-button" aria-label="Close" (click)="close()">X</button>
      </div>

      <div class="attachment-modal-content">
        @if (isImage(attachment)) {
          @if (getThumbnailUrl(attachment); as imageUrl) {
            <img class="attachment-preview" [src]="imageUrl" [alt]="getFileName(attachment)" />
          }
        } @else {
          <div class="attachment-preview-file">Preview unavailable for this file type.</div>
        }
      </div>

      <div class="attachment-modal-thumbnail-slider">
        <button
          type="button"
          class="attachment-navigation-button attachment-thumbnail-navigation-button"
          aria-label="Previous attachment"
          title="Previous attachment"
          [disabled]="imagesLoading()"
          (click)="previous()"
        >
          &lt;
        </button>
        <div class="attachment-modal-thumbnails" role="list" aria-label="Attachment thumbnails">
          <div
            class="attachment-modal-thumbnail-track"
            [style.transform]="thumbnailTrackTransform()"
          >
            @for (thumbnail of attachments(); track thumbnail.id; let index = $index) {
              <button
                type="button"
                class="attachment-modal-thumbnail"
                [class.attachment-modal-thumbnail--selected]="index === selectedIndex()"
                [attr.aria-label]="'Show ' + getFileName(thumbnail)"
                [attr.aria-current]="index === selectedIndex() ? 'true' : null"
                [disabled]="imagesLoading()"
                (click)="open(index)"
              >
                @if (isImage(thumbnail) && getThumbnailUrl(thumbnail); as thumbnailUrl) {
                  <img [src]="thumbnailUrl" [alt]="getFileName(thumbnail)" />
                } @else if (isImage(thumbnail) && imagesLoading()) {
                  <span class="attachment-thumbnail-loader" role="status" aria-label="Loading image">
                    <span class="attachment-thumbnail-loader-spinner" aria-hidden="true"></span>
                  </span>
                } @else {
                  <span>{{ getFileName(thumbnail) }}</span>
                }
              </button>
            }
          </div>
        </div>
        <button
          type="button"
          class="attachment-navigation-button attachment-thumbnail-navigation-button"
          aria-label="Next attachment"
          title="Next attachment"
          [disabled]="imagesLoading()"
          (click)="next()"
        >
          &gt;
        </button>
      </div>

      <div class="attachment-modal-footer">
        <span>{{ (selectedIndex() ?? 0) + 1 }} / {{ attachments().length }}</span>
        <button
          text-button
          variant="ghost"
          size="sm"
          symbolLeft="download"
          class="attachment-download-button"
          aria-label="Download attachment"
          title="Download attachment"
          [disable]="imagesLoading()"
          (click)="download()"
        >
          Download
        </button>
      </div>
    </section>
  </div>
}
